import { render } from "./ProductTableTotal.vue?vue&type=template&id=410934ba&scoped=true"
import script from "./ProductTableTotal.vue?vue&type=script&lang=js"
export * from "./ProductTableTotal.vue?vue&type=script&lang=js"

import "./ProductTableTotal.vue?vue&type=style&index=0&id=410934ba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410934ba"]])

export default __exports__